import settings from "../utils/settings";

const wgAuthProvider = {
  // authentication
  login: async ({ username, password }) => {
    try {
      let data = {
        locale: "en-US",
        type: "client",
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
      };
      const clientRawResult = await fetch(
        `${process.env.REACT_APP_OAUTH_ENDPOINT}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      const clientResult = await clientRawResult.json();

      data = {
        ...data,
        type: "merchant-user",
        username: `${username}${process.env.REACT_APP_MERCHANT_ID}`,
        password: password,
      };

      const rawResult = await fetch(process.env.REACT_APP_OAUTH_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${clientResult.payload.access_token}`,
        },
        body: JSON.stringify(data), // body data type must match "Content-Type" header
      });
      if (!rawResult.ok) {
        return Promise.reject("Login error");
      }
      const result = await rawResult.json();

      //Get userprofile, realm_id and branch_id
      const homeRawResult = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/merchants/home`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${result.payload.access_token}`,
          },
        }
      );
      const jsonHomeResult = await homeRawResult.json();

      const settingRawResult = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/merchant-setting/self`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${result.payload.access_token}`,
          },
        }
      );
      const jsonSettingResult = await settingRawResult.json();

      const getMerchantRole = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/merchant-roles/${jsonHomeResult.payload.user_profile.role_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${result.payload.access_token}`,
          },
        }
      );
      const roleResult = await getMerchantRole.json();

      const profile = {
        id: jsonHomeResult.payload.user_profile.id,
        username: jsonHomeResult.payload.user_profile.username,
        firstname: jsonHomeResult.payload.user_profile.firstname,
        lastname: jsonHomeResult.payload.user_profile.lastname,
        jobTitle: jsonHomeResult.payload.user_profile.job_title,
        jobUnit: jsonHomeResult.payload.user_profile.job_unit,
        imgUrl: jsonHomeResult.payload.user_profile.image_url,
        realmId: jsonHomeResult.payload.realm_profile.id,
        branchId: jsonHomeResult.payload.branch_profile?.id,
        branchName: jsonHomeResult.payload.branch_profile?.name,
        branches: jsonHomeResult.payload.branches,
        merchantName: jsonHomeResult.payload.merchant_profile.name,
        access_token: result.payload.access_token,
        refresh_token: result.payload.refresh_token,
        client_token: clientResult.payload.access_token,
        earnCash:
          jsonSettingResult.payload.merchant_config.configuration.earn_cash,
        earnPoint:
          jsonSettingResult.payload.merchant_config.configuration.earn_point,
        rewardItemId:
          jsonSettingResult.payload.merchant_config.configuration
            .reward_item_id,
        rewardInstanceId:
          jsonSettingResult.payload.merchant_config.configuration
            .reward_instance_id,
        redeemCash:
          jsonSettingResult.payload.merchant_config.configuration.redeem_cash,
        redeemPoint:
          jsonSettingResult.payload.merchant_config.configuration.redeem_point,
        currency:
          jsonSettingResult.payload.merchant_config.configuration.currency_code,
        authorizes: jsonHomeResult.payload.authorizes,
        roleId: jsonHomeResult.payload.user_profile.role_id,
        roleName: roleResult.payload.role.name,
      };

      localStorage.setItem(
        process.env.REACT_APP_LOCAL_STORAGE_NAME,
        JSON.stringify(profile)
      );

      return Promise.resolve({ redirectTo: "/" });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  checkError: (error) => {
    //Happen when occur error

    try {
      let status;
      if (typeof error === "object") {
        if (!error.status) {
          return Promise.resolve(
            JSON.stringify({
              status: 888,
              code: "INTERNAL",
              message: "No status",
            })
          );
          // return Promise.reject({ redirectTo: "/login" });
        }
        status = error.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_NAME);
          return Promise.reject({ redirectTo: "/login" });
        }

        const message = JSON.stringify(error.message);
        console.log(message);
        return Promise.resolve(
          JSON.stringify({
            status: 400,
            code: "CREATE:IM",
            message: " ต้องมี property code ด้วย",
          })
        );
      } else if (typeof error === "string") {
        return Promise.resolve(error);
      }

      return Promise.reject({ redirectTo: "/login" });
    } catch (error) {
      //Assume error is

      return Promise.resolve(error.message);
    }
  },
  checkAuth: (params) => {
    if (localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)) {
      return Promise.resolve();
    } else {
      return Promise.reject({
        redirectTo: "/login",
        message: "Need to Login first",
      });
    }
  },
  logout: async () => {
    const { token } = settings();
    await fetch(process.env.REACT_APP_OAUTH_ENDPOINT_SIGNOUT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //  body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    // if (!rawResult.ok) {
    //   return Promise.reject("Logout error");
    // } else {
    //   console.log("Good");
    // }
    //const result = await rawResult.json();
    localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_NAME);
    return Promise.resolve();
  },
  getIdentity: () => {
    try {
      const userInfo = JSON.parse(
        localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
      );
      return Promise.resolve({
        ...userInfo,
        id: userInfo.id,
        fullName: `${userInfo.firstname} ${userInfo.lastname}`,
        avatar: userInfo.imgUrl,
      });
    } catch (error) {
      return Promise.reject({ redirectTo: "/login" });
    }
  },
  // authorization
  getPermissions: (params) => {
    try {
      const userInfo = JSON.parse(
        localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
      );
      return Promise.resolve({
        roleName: userInfo.roleName,
        authorizes: userInfo.authorizes,
      });
    } catch (error) {
      return Promise.reject({ redirectTo: "/login" });
    }
  },
};
export default wgAuthProvider;
